export const takeawayLogsHeaders = [
  'S.No.',
  'Order Id',
  'Order Date',
  'Amount',
  'Status',
  'Action'
];

export const affiliateAgentsHeaders = [
  { key: 'sr_no', title: 'Sr. No' },
  { key: 'full_name', title: 'Name' },
  { key: 'email', title: 'Email' },
  { key: 'affiliate_code', title: 'Code' },
  { key: 'signups_count', title: 'Signups' },
  { key: 'subscribed_count', title: 'Subscribed' },
  { key: 'total_earned', title: 'Total Earned' },
  { key: 'pending_payout', title: 'Pending Payout' },
  { key: 'has_bank_account', title: 'Bank Added' },
  { key: 'actions', title: 'Actions' },
];

export const affiliateRequestHeaders = [
  { key: 'sr_no', title: 'Sr. No' },
  { key: 'first_name', title: 'First Name' },
  // { key: 'last_name', title: 'Last Name' },
  { key: 'email', title: 'Email' },
  { key: 'phone', title: 'Phone' },
  { key: 'created_at', title: 'Request Date' },
  { key: 'status', title: 'Status' },
  { key: 'actions', title: 'Actions' },
];


export const orderHeaders = [
  'S.No',
  'Order Id',
  'Order Date',
  'Amount',
  'Status',
  'Action'
];
export const loyaltyProgramLogsHeaders = [
  'S.No',
  'User Name',
  'Email Address',
  'Program Name',
  'Status',
  'Price',
  'Purchase Date',
  'Expiry Date',
];
export const productOrderManagementHeaders = [
  'S.No',
  'Order Id',
  'Ordered By',
  'Order Date',
  'Amount',
  'Status',
  'Action',
];
export const takeawayOrderLogsHeaders = [
  'S.No',
  'Order Id',
  'Ordered By',
  'Order Date',
  'Amount',
  'Status',
  'Action',
];
export const userManagementHeaders = [
  'S.No',
  'Full Name',
  'Verified User',
  'Subscription Type',
  'Email Address',
  'Registration Date',
  'Status',
  'Action',
];

export const verificationRequestHeaders = [
  'Full Name',
  'Email Address',
  'Requested on',
  'Status',
  'Action',
];

export const reportManagmenetHeader = [
  'S.No',
  'Full Name',
  'Email Address',
  'Reported on',
  'Status',
  'Action',
];
// export const userSubscriptionLogsHeaders = [
//   'S.No',
//   'Full Name',
//   'Verified User',
//   'Subscription Type',
//   'Email Address',
//   'Registration Date',
//   'Status',
//   'Action',
// ];
export const queryManagementHeaders = [
  'S.No',
  'Full Name',
  'Email Address',
  'subject',
  // 'Message',
  'Creation Date',
  'Action',
];
export const promocodeManagementHeaders = [
  'S.No',
  'Promo Name',
  'Promo Discount',
  'Update Date',
  'Action',
];
export const commissionManagementHeaders = [
  'Affiliate No',
  'Commission Rate',
  'Updated On',
];
export const refralPointManagementHeaders = [
  'S. No.',
  'Referral Coins',
  'Updated On',
];
export const greetingCardsLogsManagementHeaders = [
  'S. No.',
  'Full Name',
  'Email Address',
  'Card Name',
  'Coins',
  'Purchase Date',
];
export const greetingCardManagementHeaders = [
  'S. No.',
  'Card Name',
  'Coins',
  'Added On',
  'Status',
  'Action',
];
export const subscriptionLogsHeaders = [
  'S. No.',
  'Full Name',
  'Email Address',
  'Type',
  'Subscription Title',
  'Duration',
  'Discount Coins',
  'Price',
  'Purchase Date',
  'Expiry Date',
];
export const giftPurchaseLogsHeaders = [
  'S. No.',
  'Full Name',
  'Email Address',
  'Gift Title',
  'Coins',
  'Purchase Date',
];
export const giftManagementHeaders = [
  'S. No.',
  'Gift Title',
  'Coins',
  'Added On',
  'Status',
  'Action',
];
export const coinLogsHeaders = [
  'S. No.',
  'Full Name',
  'Email Address',
  'Phone',
  'Coin Bundles',
  'Price',
  'Purchase Date',
];

export const userSubscriptionLogsHeaders = [
  'S. No.',
  'Subscription Title',
  'duration',
  'Total amount',
  'payment Date',
  'expiry Date',
];
export const subscriptionPlanHeaders = [
  'S. No.',
  'Subscription Title',
  'Duration',
  'Type',
  'Price',
  'Discount Coins',
  'Coins',
  'creation date',
  'last modified',
  'Status',
  'Action',
];
export const coinManagementHeaders = [
  'S. No.',
  'CoinBundles',
  'Price',
  'AddedOn',
  'Status',
  'Action',
];
export const affiliateManagementHeader = [
  'S. No.',
  'Full Name',
  'Email Address',
  'User Type',
  'Total Commission',
  'Added On',
  'Status',
  'Action',
];
export const remindersHeaders = [
  '#',
  'Reminder Title',
  'Description',
  'Date',
  'Time',
  // 'Action',
];

export const affiliateRequestHeader = [
  'S. No.',
  'Full Name',
  'Email Address',
  'Requested On',
  'Phone',
  'Status',
  'Action',

];
